<div *ngIf='data.file' class="info">
  <div class="container-upload">
    <img *ngIf='!data.isInvalid' src="assets/images/type_execution_green.svg" alt="">
    <img *ngIf='data.isInvalid' src="assets/images/type_execution_red.svg" alt="">
    <div class="container-info">
      <div class="container-title">
        <p class="title">{{data?.file.name}}</p>
        <button *ngIf='data.info && !data.isInvalid' class="btn backgroud-icon" (click)='deleteFile(data)'></button>
        <button *ngIf='!data.info && data.isInvalid' class="btn backgroud-icon" (click)='deleteFile(data)'></button>
      </div>
      <span class="size">{{handleSize(data?.file.size)}}</span>
    </div>
    <div class="other-info">
      <div *ngIf='!data.info && !data.isInvalid' class="spinner-border" role="status"></div>
      <div *ngIf='data.info?.attribute' class="custom-badge">{{data.info?.attribute}}</div>
      <i *ngIf='data.info && !data.isInvalid' class="ic-done done-icon"></i>
      <i *ngIf='data.isInvalid' class="ic-error error-icon"></i>
    </div>
  </div>
</div>
<div class="error-message-container" *ngIf='data.isInvalid'>
  <small>{{data.error.message ? data.error.message : data.error}}</small>
</div>
<div id='edit-{{selector}}' class="edit" *ngIf='data.info && data.info.file_config && data.info.file_config.length'>
  <div class="d-inline-flex w-100">
    <span *ngFor='let options of data.info.file_config | slice:0:3' class="mx-2">{{options.choosen_value}}</span>
    <span *ngIf=' data.info.file_config > 3'>...</span>
  </div>
  <button #edit id="button-{{selector}}" type="button" class="btn collapsed btn-edit" [attr.data-toggle]="'collapse'"
    [attr.data-target]="'#section-'+ selector" [attr.aria-controls]="'section-'+ selector"
    [attr.aria-expanded]='false'>Edit</button>
</div>

<div *ngIf='data?.info && data?.info?.file_config?.length && !data?.info?.status' id="section-{{selector}}" #collapsable
  class="container contianer-collapse collapse" [attr.data-parent]="'#rootExecution'">
  <div class="config" *ngFor='let item of data.info?.file_config; let i = index'>
    <div class="col-6 name-container">
      <label class="name">{{item.name}}</label>
    </div>
    <div class="col-6 select-container">
      <ng-select
        [clearable]="false"
        placeholder='Select an option'
        class="custom select-check-value"
        bindLabel="value"
        bindValue="value"
        [(ngModel)]='item.choosen_value'
        [searchable]="false"
        [items]='item.values'
        (change)='getSelectedItem($event, item, data?.info.id)'
      >
      </ng-select>
    </div>
  </div>
</div>